import React, { useState } from "react";
import styles from "./Navbar.module.css";
import Logo from "../../assets/moodi_logo.svg";
import { Link } from "react-scroll";
import bars from "../../assets/navbar/bars-solid.svg";
import X from "../../assets/navbar/xmark-solid.svg";

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => {
    setSidebar(!sidebar);
  };

  return (
    <div className={styles.navbar}>
      <div className={styles.milogo}>
        <Link to="page1" smooth={true} duration={500}>
          <div className={styles.milogo_a}>
            <img src={Logo} alt="Moodi Logo" className="logo" />
            <div>
              <p className={styles.logoText}>Mood</p>
              <p className={styles.logoText}>Indigo</p>
            </div>
          </div>
        </Link>
      </div>
      <input type="checkbox" id={styles.check} />
      <div
        className={`${styles.bars} ${
          sidebar === true ? styles.inactivebars : styles.activebars
        }`}
      >
        <label for={styles.check} onClick={showSidebar}>
          <img src={bars} alt="bars" />
        </label>
      </div>
      <div className={styles.sidebarmenu}>
        <div
          className={`${styles.navIcons} ${
            sidebar === true ? styles.activesidebar : styles.inactivesidebar
          }`}
        >
          <div className={styles.x}>
            <label for={styles.check} onClick={showSidebar}>
              <img src={X} alt="c" />
            </label>
          </div>
          <Link to="about" smooth={true} duration={500}>
            <div className={styles.navicon}>About Us</div>
          </Link>
          <Link to="page3" smooth={true} duration={500}>
            <div className={styles.navicon}>Prizes</div>
          </Link>
          <Link to="page4" smooth={true} duration={500}>
            <div className={styles.navicon}>Schedule</div>
          </Link>
          <Link to="page5" smooth={true} duration={500}>
            <div className={styles.navicon}>Partners</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
